module.exports = __webpack_public_path__ + "static/media/toggle-open-close.2c283aa9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/toggle-open-close.svg
// module id = 919
// module chunks = 0